import { createContext, PropsWithChildren, useState } from 'react';
import { useBeforeUnloadWarning } from '@/shared/hooks/useBeforeUnloadWarning.ts';

interface BeforeUnloadContextValue {
    enabled: boolean;
    setEnabled: (enabled: boolean) => void;
}

export const BeforeUnloadContext = createContext<BeforeUnloadContextValue>({
    enabled: false,
    setEnabled: () => {
        throw new Error('BeforeUnloadContextProvider not found');
    },
});

type BeforeUnloadContextProviderProps = PropsWithChildren & {
    defaultEnabled: boolean;
};

export function BeforeUnloadContextProvider({ children, defaultEnabled }: BeforeUnloadContextProviderProps) {
    const [enabled, setEnabled] = useState(defaultEnabled);

    useBeforeUnloadWarning(enabled);

    return <BeforeUnloadContext.Provider value={{ enabled, setEnabled }}>{children}</BeforeUnloadContext.Provider>;
}
